import {DataFetcher} from '@aboutyou/data-fetcher';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import {useCanShowCouponsMinimal} from '../../../features/Coupons/useCanShowCoupons';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {usePriceAndBrandSection} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {PriceAndBrandLoading} from './PriceAndBrandLoading';
import {PriceAndBrandView} from './PriceAndBrandView';
import {useComputeDefaultState} from './utils';

export const PriceAndBrandMinimal: React.FC<{
  selectedSize: SelectedSize;
  className?: string;
  condensedView?: boolean;
  brandLogoAlignment?: string;
  productId: number;
  /**
   * Prevents showing the default state instead of the loading state.
   * The default state is an optimization related to the category page to ADP navigation,
   * to show already fetched data from the category page on the ADP.
   * For example, this is skipped in case we show this component within the mini ADP dialog.
   */
  skipDefaultState?: boolean;
  showActiveCouponBadge?: boolean;
  PriceLegalInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
}> = props => {
  const defaultState = useComputeDefaultState(props.skipDefaultState);
  const canShowCouponsMinimal = useCanShowCouponsMinimal(props.productId);

  return (
    <DataFetcher
      request={usePriceAndBrandSection(props.productId)}
      Error={() => null}
      Loading={() => <PriceAndBrandLoading className={props.className} />}
      View={viewProps => <PriceAndBrandView {...viewProps} isInMiniADPDialog />}
      viewProps={{
        ...props,
        showActiveCouponBadge:
          props.showActiveCouponBadge && canShowCouponsMinimal,
      }}
      computeDefaultState={() => defaultState}
    />
  );
};
